import React from "react";
import * as Const from "./../_Const";

const ErrorIMessage = ({ errorMessage }) => {
  const isTerminal = Const.isTerminal();
  const textClass = isTerminal ? "text-xl" : "text-sm";
  const isError = errorMessage ? true : false;
  return (
    <>
      {isError && (
        <p className={`${textClass} text-error-dark flex items-center mt-1`}>
          {errorMessage}
          <svg xmlns="http://www.w3.org/2000/svg" width="12.188" height="12.188" viewBox="0 0 12.188 12.188" fill="currentColor" className="ml-1">
            <g id="Icon_ionic-ios-close-circle-outline" data-name="Icon ionic-ios-close-circle-outline" transform="translate(-1.406 -1.406)">
              <path
                id="Path_3"
                data-name="Path 3"
                d="M9.706,9.044,8.162,7.5,9.706,5.956a.468.468,0,0,0-.662-.662L7.5,6.838,5.956,5.294a.468.468,0,0,0-.662.662L6.838,7.5,5.294,9.044a.453.453,0,0,0,0,.662.465.465,0,0,0,.662,0L7.5,8.162,9.044,9.706a.47.47,0,0,0,.662,0A.465.465,0,0,0,9.706,9.044Z"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M7.5,2.227A5.271,5.271,0,1,1,3.771,3.771,5.239,5.239,0,0,1,7.5,2.227m0-.82A6.094,6.094,0,1,0,13.594,7.5,6.093,6.093,0,0,0,7.5,1.406Z"
              />
            </g>
          </svg>
        </p>
      )}
    </>
  );
};

export default ErrorIMessage;
